(() => {
  const all = (selector) => Array.from(document.querySelectorAll(`.zendure-kit-page ${selector}`));

  function updateProductVariant(select) {
    const option = select.selectedOptions[0];
    const card = select.closest('.product-card');
    if (!option || !card) return;
    const price = card.querySelector('.price');
    const comparePrice = card.querySelector('.compare-price');
    const image = card.querySelector('.product-image');
    const link = card.querySelector('.product-link');
    const imageLink = card.querySelector('.product-image-link');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (comparePrice) comparePrice.textContent = option.dataset.compare || '';
    if (image && option.dataset.image) image.src = option.dataset.image;
    if (link && option.dataset.url) link.href = option.dataset.url;
    if (imageLink && option.dataset.url) imageLink.href = option.dataset.url;
  }

  const lightboxState = {
    modal: null,
    image: null,
    stage: null,
    closeButton: null,
    scale: 1,
    x: 0,
    y: 0,
    pointers: new Map(),
    gesture: null,
    lastTrigger: null
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  function renderLightboxTransform(animate = false) {
    if (!lightboxState.image) return;
    lightboxState.image.classList.toggle('is-animating', animate);
    lightboxState.image.style.transform = `translate3d(${lightboxState.x}px, ${lightboxState.y}px, 0) scale(${lightboxState.scale})`;
  }

  function resetLightbox(animate = true) {
    lightboxState.scale = 1;
    lightboxState.x = 0;
    lightboxState.y = 0;
    lightboxState.pointers.clear();
    lightboxState.gesture = null;
    renderLightboxTransform(animate);
  }

  function setLightboxScale(nextScale, clientX, clientY) {
    if (!lightboxState.stage) return;
    const previousScale = lightboxState.scale;
    const scale = clamp(nextScale, 1, 5);
    const rect = lightboxState.stage.getBoundingClientRect();
    const focusX = (clientX ?? rect.left + rect.width / 2) - (rect.left + rect.width / 2);
    const focusY = (clientY ?? rect.top + rect.height / 2) - (rect.top + rect.height / 2);
    const ratio = scale / previousScale;
    lightboxState.x = focusX - (focusX - lightboxState.x) * ratio;
    lightboxState.y = focusY - (focusY - lightboxState.y) * ratio;
    lightboxState.scale = scale;
    if (scale === 1) { lightboxState.x = 0; lightboxState.y = 0; }
    renderLightboxTransform(true);
  }

  function closeLightbox() {
    if (!lightboxState.modal || lightboxState.modal.hidden) return;
    lightboxState.modal.hidden = true;
    document.body.classList.remove('zd-lightbox-open');
    resetLightbox(false);
    if (lightboxState.lastTrigger) lightboxState.lastTrigger.focus({ preventScroll: true });
  }

  function ensureLightbox() {
    if (lightboxState.modal) return lightboxState.modal;
    const modal = document.createElement('div');
    modal.className = 'zd-image-lightbox';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Aperçu de l’image');
    modal.innerHTML = `
      <div class="zd-image-lightbox__toolbar">
        <button type="button" data-lightbox-action="zoom-out" aria-label="Réduire">−</button>
        <button type="button" data-lightbox-action="reset" aria-label="Réinitialiser">1:1</button>
        <button type="button" data-lightbox-action="zoom-in" aria-label="Agrandir">+</button>
        <button type="button" class="zd-image-lightbox__close" data-lightbox-action="close" aria-label="Fermer">×</button>
      </div>
      <div class="zd-image-lightbox__stage"><img class="zd-image-lightbox__image" alt=""></div>`;
    document.body.appendChild(modal);
    lightboxState.modal = modal;
    lightboxState.stage = modal.querySelector('.zd-image-lightbox__stage');
    lightboxState.image = modal.querySelector('.zd-image-lightbox__image');
    lightboxState.closeButton = modal.querySelector('[data-lightbox-action="close"]');

    modal.addEventListener('click', (event) => {
      const action = event.target.closest('[data-lightbox-action]')?.dataset.lightboxAction;
      if (action === 'close' || event.target === modal) closeLightbox();
      if (action === 'zoom-in') setLightboxScale(lightboxState.scale + 0.5);
      if (action === 'zoom-out') setLightboxScale(lightboxState.scale - 0.5);
      if (action === 'reset') resetLightbox();
    });
    lightboxState.stage.addEventListener('wheel', (event) => {
      event.preventDefault();
      setLightboxScale(lightboxState.scale + (event.deltaY < 0 ? 0.35 : -0.35), event.clientX, event.clientY);
    }, { passive: false });
    lightboxState.stage.addEventListener('dblclick', (event) => {
      setLightboxScale(lightboxState.scale > 1 ? 1 : 2.25, event.clientX, event.clientY);
    });
    lightboxState.stage.addEventListener('pointerdown', (event) => {
      lightboxState.stage.setPointerCapture(event.pointerId);
      lightboxState.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const points = Array.from(lightboxState.pointers.values());
      if (points.length === 1) {
        lightboxState.gesture = { type: 'pan', startX: points[0].x, startY: points[0].y, x: lightboxState.x, y: lightboxState.y };
      } else if (points.length === 2) {
        lightboxState.gesture = {
          type: 'pinch',
          distance: Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y),
          scale: lightboxState.scale,
          centerX: (points[0].x + points[1].x) / 2,
          centerY: (points[0].y + points[1].y) / 2,
          x: lightboxState.x,
          y: lightboxState.y
        };
      }
      lightboxState.image.classList.remove('is-animating');
    });
    lightboxState.stage.addEventListener('pointermove', (event) => {
      if (!lightboxState.pointers.has(event.pointerId)) return;
      lightboxState.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      const points = Array.from(lightboxState.pointers.values());
      if (points.length === 2 && lightboxState.gesture?.type === 'pinch') {
        const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
        const centerX = (points[0].x + points[1].x) / 2;
        const centerY = (points[0].y + points[1].y) / 2;
        lightboxState.scale = clamp(lightboxState.gesture.scale * distance / Math.max(lightboxState.gesture.distance, 1), 1, 5);
        lightboxState.x = lightboxState.gesture.x + centerX - lightboxState.gesture.centerX;
        lightboxState.y = lightboxState.gesture.y + centerY - lightboxState.gesture.centerY;
        renderLightboxTransform();
      } else if (points.length === 1 && lightboxState.gesture?.type === 'pan' && lightboxState.scale > 1) {
        lightboxState.x = lightboxState.gesture.x + points[0].x - lightboxState.gesture.startX;
        lightboxState.y = lightboxState.gesture.y + points[0].y - lightboxState.gesture.startY;
        renderLightboxTransform();
      }
    });
    const endPointer = (event) => {
      lightboxState.pointers.delete(event.pointerId);
      const points = Array.from(lightboxState.pointers.values());
      if (points.length === 1) {
        lightboxState.gesture = { type: 'pan', startX: points[0].x, startY: points[0].y, x: lightboxState.x, y: lightboxState.y };
      } else if (!points.length) lightboxState.gesture = null;
    };
    lightboxState.stage.addEventListener('pointerup', endPointer);
    lightboxState.stage.addEventListener('pointercancel', endPointer);
    return modal;
  }

  function openLightbox(trigger) {
    const modal = ensureLightbox();
    lightboxState.lastTrigger = trigger;
    resetLightbox(false);
    lightboxState.image.src = trigger.dataset.lightboxSrc;
    lightboxState.image.alt = trigger.dataset.lightboxAlt || '';
    modal.hidden = false;
    document.body.classList.add('zd-lightbox-open');
    requestAnimationFrame(() => lightboxState.closeButton.focus({ preventScroll: true }));
  }

  function positionFunctionPopover(button, popover) {
    if (!popover || window.getComputedStyle(popover).display === 'none') return;
    const stage = button.closest('.function-stage');
    if (!stage) return;
    const stageRect = stage.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const gap = 14;
    const inset = 12;
    const buttonLeft = buttonRect.left - stageRect.left;
    const buttonTop = buttonRect.top - stageRect.top;
    let left = buttonLeft;
    let top = buttonTop;
    if (popover.dataset.placement === 'left') {
      left = buttonLeft - popoverRect.width - gap;
      top = buttonTop + (buttonRect.height - popoverRect.height) / 2;
    } else if (popover.dataset.placement === 'right') {
      left = buttonLeft + buttonRect.width + gap;
      top = buttonTop + (buttonRect.height - popoverRect.height) / 2;
    } else if (popover.dataset.placement === 'top') {
      left = buttonLeft + (buttonRect.width - popoverRect.width) / 2;
      top = buttonTop - popoverRect.height - gap;
    } else {
      left = buttonLeft + (buttonRect.width - popoverRect.width) / 2;
      top = buttonTop + buttonRect.height + gap;
    }
    popover.style.left = `${Math.max(inset, Math.min(left, stageRect.width - popoverRect.width - inset))}px`;
    popover.style.top = `${Math.max(inset, Math.min(top, stageRect.height - popoverRect.height - inset))}px`;
  }

  function showFunctionDetail(button) {
    const popover = document.getElementById(button.dataset.popover);
    positionFunctionPopover(button, popover);
    all('.zd-lightbox-trigger').forEach((trigger) => {
      if (trigger.dataset.zdBound) return;
      trigger.addEventListener('click', () => openLightbox(trigger));
      trigger.dataset.zdBound = 'true';
    });

    all('.function-hotspot').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', String(active));
    });
    all('.function-popover').forEach((item) => item.classList.toggle('is-active', item === popover));
    const detailTitle = document.getElementById('function-detail-title');
    const detailText = document.getElementById('function-detail-text');
    if (detailTitle) detailTitle.textContent = button.dataset.title || '';
    if (detailText) detailText.textContent = button.dataset.detail || '';
  }

  function activateComparisonTab(tab) {
    const tabs = all('.mobile-comparison-tab');
    tabs.forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
    all('.comparison-detail-row').forEach((row) => row.classList.toggle('is-active', row.id === tab.dataset.compareTarget));
    tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }

  function initZendureKitPage() {
    all('.variant-select').forEach((select) => {
      if (!select.dataset.zdBound) {
        select.addEventListener('change', () => updateProductVariant(select));
        select.dataset.zdBound = 'true';
      }
      updateProductVariant(select);
    });

    all('.function-hotspot').forEach((button) => {
      if (button.dataset.zdBound) return;
      button.addEventListener('mouseenter', () => showFunctionDetail(button));
      button.addEventListener('focus', () => showFunctionDetail(button));
      button.addEventListener('click', () => showFunctionDetail(button));
      button.dataset.zdBound = 'true';
    });
    const initialFunctionButton = document.querySelector('.zendure-kit-page .function-hotspot.is-active');
    if (initialFunctionButton) showFunctionDetail(initialFunctionButton);

    all('.scene-tab').forEach((tab) => {
      if (tab.dataset.zdBound) return;
      tab.addEventListener('click', () => {
        all('.scene-tab').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
        const targetPanel = document.getElementById(`scene-${tab.dataset.scene}`);
        if (!targetPanel) return;
        all('.scene-panel').forEach((panel) => { panel.hidden = panel !== targetPanel; });
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          targetPanel.animate(
            [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 320, easing: 'cubic-bezier(.22, .8, .32, 1)' }
          );
        }
      });
      tab.dataset.zdBound = 'true';
    });

    const comparisonTabs = all('.mobile-comparison-tab');
    comparisonTabs.forEach((tab, index) => {
      if (tab.dataset.zdBound) return;
      tab.addEventListener('click', () => activateComparisonTab(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = comparisonTabs[(index + direction + comparisonTabs.length) % comparisonTabs.length];
        next.focus();
        activateComparisonTab(next);
      });
      tab.dataset.zdBound = 'true';
    });
  }

  if (!document.documentElement.dataset.zdKitResizeBound) {
    window.addEventListener('resize', () => {
      const activeButton = document.querySelector('.zendure-kit-page .function-hotspot.is-active');
      if (activeButton) positionFunctionPopover(activeButton, document.getElementById(activeButton.dataset.popover));
    });
    document.documentElement.dataset.zdKitResizeBound = 'true';
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeLightbox();
  });

  initZendureKitPage();
  document.addEventListener('shopify:section:load', initZendureKitPage);
})();
